export interface CompanyContacts {
  roleLabel: string;
  fullLegalName: string;
  legalAddress: string;
  postalAddress?: string;
  ogrn: string;
  inn: string;
  kpp: string;
  directorLabel: string;
  director: string;
  phone?: string;
  phoneHref?: string;
  email?: string;
  bankAccount?: string;
  bankName?: string;
  bik?: string;
  corrAccount?: string;
}

export const LICENSOR_CONTACTS: CompanyContacts = {
  roleLabel: "Лицензиар",
  fullLegalName:
    "Общество с ограниченной ответственностью «Лаборатория информационной безопасности»",
  legalAddress: "105082, Москва, Большая Почтовая ул., д. 26В, стр. 1, офис 407",
  postalAddress: "105082, Москва, Большая Почтовая ул., д. 26В, стр. 1, офис 407",
  ogrn: "1147746651997",
  inn: "7725831654",
  kpp: "770101001",
  directorLabel: "Генеральный директор",
  director: "Андреева Анна Николаевна",
  phone: "+7 (495) 723-72-75",
  phoneHref: "tel:+74957237275",
  email: "info@islg.ru",
};

export const LICENSEE_CONTACTS: CompanyContacts = {
  roleLabel: "Лицензиат (Дистрибьютор)",
  fullLegalName: 'Общество с ограниченной ответственностью "ЦИНГУЛАТА"',
  legalAddress:
    "115114, Город Москва, вн.тер. г. Муниципальный Округ Замоскворечье, ул Летниковская, дом 10, строение 4, этаж 1, комната 20",
  ogrn: "1207700174010",
  inn: "9719003818",
  kpp: "770501001",
  directorLabel: "Управляющий",
  director: "Индивидуальный предприниматель Солодовников Кирилл Юрьевич",
  bankAccount: "40702810420000294877",
  bankName: 'ООО "Банк Точка"',
  bik: "044525104",
  corrAccount: "30101810745374525104",
};

export const COMPANY_REQUISITES: readonly CompanyContacts[] = [
  LICENSOR_CONTACTS,
  LICENSEE_CONTACTS,
];

export const COMPANY_CONTACTS = LICENSOR_CONTACTS;
